// extracted by mini-css-extract-plugin
export default {"payment-plan__fee-notice":"styles_payment-plan__fee-notice__XOdDg","individual-payment-plan__installments-table":"styles_individual-payment-plan__installments-table__ZcDix"};